export default "__VITE_ASSET__ce97bd51__"